import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/unknow.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1b3a965d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cm-align-center gap-x-15",
  style: {"flex":"1"}
}
const _hoisted_2 = ["alt"]
const _hoisted_3 = { style: {"flex":"1"} }
const _hoisted_4 = { style: {"font-size":"18px","color":"var(--cm-color-text-primary)"} }
const _hoisted_5 = {
  class: "gap-x-20",
  style: {"margin-left":"auto","display":"flex"}
}
const _hoisted_6 = {
  class: "",
  style: {"color":"var(--cm-color-text-secondary)","text-align":"right"}
}
const _hoisted_7 = {
  class: "cm-ui-mt10",
  style: {"color":"var(--cm-color-text-primary)","text-align":"right"}
}
const _hoisted_8 = {
  class: "",
  style: {"color":"var(--cm-color-text-secondary)","text-align":"right"}
}
const _hoisted_9 = {
  class: "cm-ui-mt10",
  style: {"color":"var(--cm-color-text-primary)","text-align":"right"}
}
const _hoisted_10 = {
  class: "",
  style: {"margin":"20px"}
}

import SafetyTags from '@/components/safety-tags/safety-tags.vue'
import { computed, PropType, ref, watch } from 'vue'
import Describe from './components/Describe.vue'
import { EventListItem } from './service'
import { useI18n } from 'vue-i18n'
import { Level, ProtectionType, trProtectionDesc, trBlockStatus } from './types/ransomware-incident'
import { formatTimeStamp } from '@/utils/time'

const activeName = 'first'


export default /*#__PURE__*/_defineComponent({
  __name: 'ransomware-incident-detail',
  props: {
  detailInfo: {
    type: Object as PropType<EventListItem>,
    required: true
  },
  direction: {
    type: String,
    default: 'right',
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'addWhiteList'],
  setup(__props, { emit: __emit }) {

const props = __props

const { t, locale } = useI18n()

const drawerTitle = computed(() => {
  void locale.value
  return t('ransomwareIncident.detailTitle', { name: props.detailInfo.computer_name || '' })
})
const eventDescText = computed(() => {
  void locale.value
  return trProtectionDesc(t, props.detailInfo.defence_type || 0)
})
const blockStatusText = computed(() => {
  void locale.value
  return trBlockStatus(t, props.detailInfo.status)
})

const emits = __emit
const currentCardType = computed(() => Level[props.detailInfo.level]?.toLowerCase?.())
const drawer = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', value)
  },
})
const addWhiteList = (val: string) => {
  emits('addWhiteList', val)
}
const describeList = ref([])
const describeObj = ref([])
watch(() => props.modelValue, (nv) => {
  if (nv) {
    const obj = JSON.parse(props.detailInfo.risk_info || '{}')
    const payloadObj = JSON.parse(obj.payload || '[]')
    const list = payloadObj.map((item: { k: string, v: string }) => ({ label: item.k, copy: item.k.includes('MD') || item.k.includes('路径'), link: item.k.includes('MD'), prop: item.k }))
    const specialObj = {
      ...obj,
      description: `【${obj.title}】${obj.description}`,
      ...payloadObj.reduce((p, c, i) => (p[c.k] = c.v, p), {}),
      creation_time: formatTimeStamp(props.detailInfo.operate_time, 'YYYY-MM-DD HH:mm')
    }
    describeList.value = list
    describeObj.value = specialObj
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
    title: drawerTitle.value,
    direction: "rtl",
    size: "45%",
    "custom-class": "cm-drawer"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["card", currentCardType.value + '-card'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (__props.detailInfo.level !== _unref(Level).Default)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(["iconfont cm-icon-warning", currentCardType.value]),
                style: {"font-size":"60px","position":"relative","top":"5px"}
              }, null, 2))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                width: "60",
                height: "60",
                src: _imports_0,
                alt: _unref(t)('ransomwareIncident.unknown'),
                style: {"position":"relative","top":"5px"}
              }, null, 8, _hoisted_2)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(eventDescText.value), 1),
            _createVNode(SafetyTags, {
              data: __props.detailInfo.tags,
              max: 5
            }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('ransomwareIncident.state')), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(blockStatusText.value), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.detailInfo.group_name), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(__props.detailInfo.user_mark || '--'), 1)
          ])
        ])
      ], 2),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_tabs, {
          modelValue: activeName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName) = $event)),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _unref(t)('ransomwareIncident.eventInfo'),
              name: "first"
            }, {
              default: _withCtx(() => [
                (_unref(ProtectionType).RansomwareSignatureIdentification === (__props.detailInfo.defence_type || 0))
                  ? (_openBlock(), _createBlock(Describe, {
                      key: 0,
                      type: "source",
                      describeLs: describeList.value,
                      "detail-info-obj": describeObj.value
                    }, null, 8, ["describeLs", "detail-info-obj"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(Describe, {
                        onAddWhiteList: addWhiteList,
                        type: "source",
                        "detail-info-obj": __props.detailInfo.operator_fields
                      }, null, 8, ["detail-info-obj"]),
                      _createVNode(Describe, {
                        onAddWhiteList: addWhiteList,
                        type: "target",
                        "detail-info-obj": __props.detailInfo.target_fields
                      }, null, 8, ["detail-info-obj"])
                    ], 64))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})